export abstract class VesselFeedbackStatusBase extends EventTarget
{
  abstract setVesselFeedback(payload: any): Promise<void>;
  abstract getVesselFeedback(): Promise<void>;
}

let VesselFeedbackStatusModel: VesselFeedbackStatusBase|null = null;

function setVesselFeedbackStatusModel(model: VesselFeedbackStatusBase)
{
  VesselFeedbackStatusModel = model;
}

export { VesselFeedbackStatusModel, setVesselFeedbackStatusModel };
